import { PermitType, PermitRenewalPeriod } from "common/types/permits";

/**
 * Vehicle summary for display in the review step
 */
export interface ReviewVehicle {
  id: string;
  licensePlate: string;
  stateCode: string;
  make: string | null;
  model: string | null;
  year: number | null;
}

/**
 * Document status for display in the review step
 */
export interface ReviewDocument {
  documentTypeId: string;
  documentTypeName: string;
  /** Document ID if uploaded, null if pending */
  documentId: string | null;
}

/**
 * Fee summary for display when payment processing is enabled
 */
export interface FeeSummary {
  /** Base price per renewal period in cents */
  basePrice: number;
  /** Number of vehicles (relevant for per_vehicle scope) */
  vehicleCount: number;
  /** Whether pricing is per vehicle */
  isPerVehicle: boolean;
  /** Total fee in cents */
  totalFee: number;
  /** Human-readable renewal period label */
  renewalPeriodLabel: string;
}

/**
 * Props for the ReviewSubmitStepContent presentation component
 */
export interface ReviewSubmitStepContentProps {
  /** Authority name (required - step 1 must be complete) */
  authorityName: string;
  /** Authority ID used to render authority-specific terms */
  authorityId: string;
  /** Selected permit type (required - step 2 must be complete) */
  permitType: PermitType;
  /** Vehicles selected for the permit (empty for per_account scope) */
  vehicles: ReviewVehicle[];
  /** Whether vehicles are loading */
  vehiclesLoading: boolean;
  /** Documents with upload status */
  documents: ReviewDocument[];
  /** ISO timestamp when terms were accepted, or null if not yet accepted */
  termsAcceptedAt: string | null;
  /** Called when terms checkbox changes - receives ISO timestamp when checked, null when unchecked */
  onTermsChange: (acceptedAt: string | null) => void;
}

/**
 * Format renewal period for display
 */
export function formatRenewalPeriod(period: PermitRenewalPeriod): string {
  switch (period) {
    case "annual":
      return "per year";
    case "monthly":
      return "per month";
    case "quarterly":
      return "per quarter";
    default:
      return period;
  }
}
